const sizeOptionsCAtoEU = {
  4.5: 35,  
  5.5: 36,  
  6: 37,
  7: 38,
  8: 39,  
  8.5: 40,
  9.5: 41,
  10: 42,
  11: 43,
  11.5: 44,
  12.5: 45,
  13: 46,
  13.5: 47,
  14: 48,
};
const sizeOptionsEUtoCA = {
  35: 4.5,  
  36: 5.5,  
  37: 6,
  38: 7,
  39: 8,  
  40: 8.5,
  41: 9.5,
  42: 10,
  43: 11,
  44: 11.5,
  45: 12.5,
  46: 13,
  47: 13.5,
  48: 14,
};

var buttonsSize = document.querySelectorAll('.size-options-container button');

var buttonSizeOptionSelected = document.querySelectorAll('.size-content .size-option button');
var buttonSizeOptionSelected2 = document.querySelectorAll('.size-content .size-option button');
[].forEach.call(buttonSizeOptionSelected, function(buttonSelected) {
  buttonSelected.addEventListener('click', (e) => {
    if(!e.target.classList.contains('active')){
      [].forEach.call(buttonSizeOptionSelected2, function(buttonSelected2) {
        buttonSelected2.classList.remove("active");
      });
      e.target.classList.add("active");
      
      let sizeOptions = sizeOptionsCAtoEU; 
      if(e.target.innerText === "CA"){ sizeOptions = sizeOptionsEUtoCA; }
      
      [].forEach.call(buttonsSize, function(button) {
        button.innerText = sizeOptions[parseFloat(button.innerText)];
      });
    }
  });
});


const varSizeOptionsWomen = [
  [35, 4.5],
  [36, 5.5],
  [37, 6],
  [38, 7],
  [39, 8],
  [40, 8.5],
  [41, 9.5],
  [42, 10],
  [43, 11],
  [44, 11.5],
  [45, 12.5]
];

const varSizeOptionsMen = [
  [39, 7],
  [40, 7.5],
  [41, 8],
  [42, 9],
  [43, 10],
  [44, 10.5],
  [45, 11.5],
  [46, 12],
  [47, 13],
  [48, 14]
];

var tableSizesOptionsWomen = document.querySelector('.table-sizes-options .women');
varSizeOptionsWomen.map(function(e){  
  var tableOptionDiv = document.createElement("div");
  tableOptionDiv.classList.add('table-option');
  
  var text1 = document.createElement("div");
  text1.classList.add('text');
  text1.innerText = e[0];  
  tableOptionDiv.appendChild(text1);
  
  var text2 = document.createElement("div");
  text2.classList.add('text');
  text2.innerText = e[1];
  tableOptionDiv.appendChild(text2);
  
  tableSizesOptionsWomen.appendChild(tableOptionDiv);
});

var tableSizesOptionsMen = document.querySelector('.table-sizes-options .men');
varSizeOptionsMen.map(function(e){  
  var tableOptionDiv = document.createElement("div");
  tableOptionDiv.classList.add('table-option');
  
  var text1 = document.createElement("div");
  text1.classList.add('text');
  text1.innerText = e[0];  
  tableOptionDiv.appendChild(text1);
  
  var text2 = document.createElement("div");
  text2.classList.add('text');
  text2.innerText = e[1];
  tableOptionDiv.appendChild(text2);
  
  tableSizesOptionsMen.appendChild(tableOptionDiv);
});


var buttonSizeOptionSelected = document.querySelectorAll('.content-size-guide .size-option button');
[].forEach.call(buttonSizeOptionSelected, function(buttonSelected) {
  buttonSelected.addEventListener('click', (e) => {
    if(!e.target.classList.contains('active')){
      [].forEach.call(buttonSizeOptionSelected, function(buttonSelected) {
        buttonSelected.classList.remove("active");
      });
      e.target.classList.add("active");
  
      if(tableSizesOptions.classList.contains('reverse')){
        tableSizesOptions.classList.remove('reverse');
      }else{
        tableSizesOptions.classList.add('reverse');
      }
    }
  });
});

document.querySelector('.container-size-guide-options .content-size-guide .head-size svg').addEventListener('click', (e) => {
  document.querySelector('.container-size-guide-options').classList.remove('show');
});

document.querySelector('.size-content .size-guide a').addEventListener('click', (e) => {
  document.querySelector('.container-size-guide-options').classList.add('show');
});

document.addEventListener("click", function(evt) {
  let focusEl = document.querySelector('.container-size-guide-options .empty-content');
  let targetEl = evt.target; 
  if(targetEl == focusEl){ document.querySelector('.container-size-guide-options').classList.remove('show'); }
});